import React, {Component} from 'react';
import { connect } from 'react-redux';

class App extends Component {

    render() {
        const { app } = this.props;
        let appViewData = app.appViewData;
        let view = null;

        return (
            <div>
                <h1>Página de error</h1>
                <div>
                    <p>Título: {appViewData.errorTitle}</p>
                    <p>Mensaje: {appViewData.errorMessage}</p>
                    <p>Por favor, pulse en el menú para navegar a otra página</p>
                </div>
            </div>
            
        );
    }
}

function mapStateToProps(state) {
    return {        
        app: state.app
    };
}

function mapDispatchToProps(dispatch) {
    return {
        
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);